/**
 * @generated SignedSource<<419792ae0495b9b2ed73df434c35e594>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VaultAccessDetails_node$data = {
  readonly canUpdate: {
    readonly value: boolean;
  };
  readonly id: string;
  readonly members: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
  }>;
  readonly name: string;
  readonly vaultManagementGroup: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"VaultManagementGroupLabel_vaultManagementGroup">;
  };
  readonly " $fragmentType": "VaultAccessDetails_node";
};
export type VaultAccessDetails_node$key = {
  readonly " $data"?: VaultAccessDetails_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"VaultAccessDetails_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VaultAccessDetails_node",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canUpdate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "members",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserHandle_member"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VaultManagementGroup",
      "kind": "LinkedField",
      "name": "vaultManagementGroup",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "VaultManagementGroupLabel_vaultManagementGroup"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Vault",
  "abstractKey": null
};
})();

(node as any).hash = "e10c08ff58b5fc3b93ed8c7578b7e6f4";

export default node;
